





















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { capitalize } from "lodash";
import { firestore } from "@/configs/firebase";

@Component
export default class AgentCard extends Vue {
  @Prop() active!: boolean;
  @Prop() status!: string;
  @Prop() item!: any;
  @Prop() duration!: string;
  @Prop() idleTime!: string;
  @Prop() waitingTime!: string;
  @Prop() call!: any;
  @Prop() isDisabled!: boolean;
  @Prop() select!: Function;
  @Prop({ default: () => {} }) toggle!: Function;

  selectAgent(): void {
    this.select(this.item);
    this.toggle();
  }

  getInitials(agent: any): string {
    return agent.email.slice(0, 2);
  }

  getName(agent: any): string {
    return capitalize(agent.email.split("@")[0]);
  }

  getCloserPriority(agent: any): string {
    return agent.closer_priority || "0";
  }

  get statusColor(): string {
    if (this.status === "active") {
      if (this.call) return "green lighten-1";
      else return "purple darken-4";
    }
    if (this.status === "available") {
      return "blue lighten-1";
    }
    return "white";
  }
}
